import React, { Component } from "react";
import BarGraphCard from "../components/BarGraphCard";
import PieChartCard from "../components/PieChartCard";
import PieChartProgressCard from "../components/PieChartProgressCard";
import { connect } from "react-redux";
import * as actions from "../../app/modules/Hamropalika/_redux/WardRedux";
class Buildings extends Component {
	constructor(props) {
		super(props);
		this.state = {
			barData: [],
			surveyData: [],
		};
	}
	componentDidMount() {
		this.props.dispatch(actions.fetchHouseCertificate());
		this.props.dispatch(actions.fetchHouseMapPass());
		this.props.dispatch(actions.fetchHouseCount());
		this.props.dispatch(actions.fetchHouseType());
	}
	componentWillReceiveProps(nextProps) {
		if (nextProps.detail !== this.props.detail) {
			let surveyData = [
				{
					id: 1,
					data: nextProps.detail.selectedHouseCertificate?.data.map(
						({ value }) => value
					),
					containerClass: "col-md-6 col-lg-4",
					labels: nextProps.detail.selectedHouseCertificate?.data.map(
						({ value }) => value
					),
					labelDesc: nextProps.detail.selectedHouseCertificate?.data.map(
						(datum) => {
							return datum[nextProps.detail.selectedLanguage];
						}
					),
					title:
						nextProps.detail.houseCertificateList.title[
							nextProps.detail.selectedLanguage
						],
					color: "success",
					value: nextProps.detail.houseCertificateList.percentage,
				},
				{
					id: 2,
					data: nextProps.detail.selectedHouseMapPass?.data.map(
						({ value }) => value
					),
					containerClass: "col-md-6 col-lg-4",
					labels: nextProps.detail.selectedHouseMapPass?.data.map(
						({ value }) => value
					),
					labelDesc: nextProps.detail.selectedHouseMapPass?.data.map(
						(datum) => {
							return datum[nextProps.detail.selectedLanguage];
						}
					),
					title:
						nextProps.detail.houseMapPassList.title[
							nextProps.detail.selectedLanguage
						],
					color: "success",
					value: nextProps.detail.houseMapPassList.percentage,
				},
			];
			this.setState({ surveyData });
		}

		if (
			nextProps.detail.selectedHouseCount !==
				this.props.detail.selectedHouseCount ||
			nextProps.detail.selectedLanguage !== this.props.detail.selectedLanguage
		) {
			let totalData = nextProps.detail.selectedHouseCount?.data.map(
				({ value }) => value
			);
			let labelData = nextProps.detail.selectedHouseCount?.data.map((datum) => {
				return datum[nextProps.detail.selectedLanguage];
			});
			let houseCountData = {
				id: 1,
				values: [
					{
						name: "",
						data: totalData,
					},
				],
				title:
					nextProps.detail.houseCountList.title[
						nextProps.detail.selectedLanguage
					],
				categories: labelData,
				detail: "HouseCount",
				color: "#C490E4",
				xaxis: "Number of houses",
				xaxis_nepali: "घर संख्या",
			};
			this.setState((previousState) => {
				let barData = previousState.barData;
				let prevWardData = previousState.barData.find((i) => i.id == 1);
				if (!prevWardData) {
					barData.push(houseCountData);
				} else {
					let prevWardDataIndex = previousState.barData.indexOf(prevWardData);
					barData[prevWardDataIndex] = houseCountData;
				}
				return {
					barData,
				};
			});
		}
		if (
			nextProps.detail.selectedHouseType !==
				this.props.detail.selectedHouseType ||
			nextProps.detail.selectedLanguage !== this.props.detail.selectedLanguage
		) {
			let totalData = nextProps.detail.selectedHouseType?.data.map(
				({ value }) => value
			);
			let labelData = nextProps.detail.selectedHouseType?.data.map((datum) => {
				return datum[nextProps.detail.selectedLanguage];
			});
			let houseTypeData = {
				id: 2,
				values: [
					{
						name: "",
						data: totalData,
					},
				],
				title:
					nextProps.detail.houseTypeList.title[
						nextProps.detail.selectedLanguage
					],
				categories: labelData,
				detail: "HouseType",
				color: "#01937C",
				xaxis: "Type of roof",
				xaxis_nepali: "घरको बनावटको आधारमा",
			};
			this.setState((previousState) => {
				let barData = previousState.barData;
				let prevWardData = previousState.barData.find((i) => i.id == 2);
				if (!prevWardData) {
					barData.push(houseTypeData);
				} else {
					let prevWardDataIndex = previousState.barData.indexOf(prevWardData);
					barData[prevWardDataIndex] = houseTypeData;
				}
				return {
					barData,
				};
			});
		}
	}
	render() {
		return (
			<div className="row">
				{this.state.barData.map((datum, index) => {
					return (
						<BarGraphCard
							key={index}
							datum={datum}
							section="buildings_bar_graph"
						/>
					);
				})}
				{this.state.surveyData.map((data, index) => {
					return (
						<PieChartCard
							data={data}
							key={index}
							section="buildings_pie_chart_"
						/>
					);
				})}
			</div>
		);
	}
}

const mapStateToProps = (state) => ({
	detail: state.ward,
});
export default connect(mapStateToProps)(Buildings);
